import React, { useState, useEffect } from "react";
import HeaderDashboard from "./HeaderDashboard";
import SidebarDashboard from "./SidebarDashboard";
import ContentDashboard from "./ContentDashboard";
import Header from "../Header/Header";
import axios from "axios";
import { BaseUrl } from "../../Constant/Config";
import { useHistory } from "react-router-dom";

const Dashboard = () => {
  const history = useHistory();
  const [chartContent, setChartContent] = useState();
  const [chartSidebar, setChartSidebar] = useState();
  const [topUser, setTopUser] = useState();
  const [headerDashboard, setHeaderDashboard] = useState();

  const apiCharts = () => {
    axios
      .get(`${BaseUrl}/dashboard?api_token=${localStorage.getItem("token")}`)
      .then((res) => {
        setChartSidebar(res.data.data);
        setChartContent(res.data.data);
        setTopUser(res.data.data.topUser);
        setHeaderDashboard(res.data.data.checkpointInfo);
      })
      .catch((error) => {
        return error.response.data.status === 401
          ? history.push("/login")
          : null;
      });
  };

  useEffect(() => {
    apiCharts();
  }, []);
  return (
    <div className="dashboard-main">
      <Header />
      <div className="col-12 container">
        <div className="col-md-5 col-12 pr-0 pl-0 float-right side-bar-dashbord">
          <SidebarDashboard data={chartSidebar} topUser={topUser} />
        </div>
        <div className="col-md-7 col-12 float-right sticymenu p-0 my-5 ">
          <div className="col-12 p-0 mr-md-4">
            <HeaderDashboard data={headerDashboard} />
          </div>
          <div className="col-12 p-0 mr-md-4">
            <ContentDashboard data={chartContent} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
